import React from 'react';
import { Tr, Td } from '../../shared/customTable.styled';

const PricesRow = ({ titulo, valor, desconto, valor_editavel, valor_final }) => {
  const price = valor_editavel > 0 ? valor_editavel : valor;
  return (
  <Tr>
    <Td width="213">{titulo == 'FC REPORT' && <span>FC REPORT</span> || titulo}</Td>
    <Td width="150">R$ {price}</Td>
    {desconto &&
      <Td>R$ {desconto}</Td>
    }
    <Td width="187">
      R$ {valor_final}
    </Td>
  </Tr>
)};


export default PricesRow;
